import type { MatchItem } from '../types';
import {
  replacePartnerPlaceholder,
} from '../lib/resultsDisplay';

const INTENSITY_EMOJI: Record<string, string> = {
  open: '🤔',
  like: '🥰',
  love: '🔥',
};

const INTENSITY_LABEL: Record<string, string> = {
  open: 'Curious',
  like: 'Yes please',
  love: 'Hell yes!',
};

interface MatchCardProps {
  match: MatchItem;
  partnerAName: string;
  partnerBName: string;
}

export default function MatchCard({
  match,
  partnerAName,
  partnerBName,
}: MatchCardProps) {
  const isCounterpart = match.matchType === 'counterpart' && match.counterpartQuestionText;

  const promptA = isCounterpart
    ? replacePartnerPlaceholder(match.questionText, partnerBName)
    : null;
  const promptB = isCounterpart
    ? replacePartnerPlaceholder(match.counterpartQuestionText!, partnerAName)
    : null;

  return (
    <div className="flex items-center gap-3 px-4 py-3.5 border-b border-white/[0.07] last:border-b-0 transition-colors hover:bg-white/[0.03]">
      <p className="min-w-0 flex-1 text-[0.9rem] font-medium text-white leading-snug break-words">
        {isCounterpart ? (
          <>
            {promptA}
            <span className="swap-icon inline-flex items-center justify-center mx-1.5 px-2 py-1 rounded-md bg-white/[0.12] relative -top-px">
              <svg width="16" height="8" viewBox="0 0 16 8" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="text-white/50">
                <path d="M1 4h14" />
                <path d="M5 1L1 4l4 3" />
                <path d="M11 1l4 3-4 3" />
              </svg>
            </span>
            {promptB}
          </>
        ) : (
          replacePartnerPlaceholder(match.questionText, partnerBName)
        )}
      </p>
      <span
        className="flex-shrink-0 text-xl leading-none w-9 sm:w-[50px] text-center"
        title={`${partnerAName}: ${INTENSITY_LABEL[match.intensityA]}`}
        aria-label={`${partnerAName}: ${INTENSITY_LABEL[match.intensityA]}`}
      >
        {INTENSITY_EMOJI[match.intensityA]}
      </span>
      <span
        className="flex-shrink-0 text-xl leading-none w-9 sm:w-[50px] text-center"
        title={`${partnerBName}: ${INTENSITY_LABEL[match.intensityB]}`}
        aria-label={`${partnerBName}: ${INTENSITY_LABEL[match.intensityB]}`}
      >
        {INTENSITY_EMOJI[match.intensityB]}
      </span>
    </div>
  );
}
